import React, { useCallback, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import FinancialInstitutionsModal from '@/modules/financials/components/FinancialInstitutionsModal';

const FinancialSectionAddButton = ({ refreshTask, children }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Button
        type="button"
        color="success"
        size="medium"
        variant="contained"
        startIcon={<AddIcon />}
        onClick={openModal}
      >
        {children || t('Add financial institutions')}
      </Button>
      <FinancialInstitutionsModal
        open={open}
        onClose={closeModal}
        refreshTask={refreshTask}
      />
    </>
  );
};

export default FinancialSectionAddButton;
